/**
 * Color utility functions for the Fyncall Widget
 */

/**
 * Color name to hex code mapping
 * Used for variant options in product displays
 */
export const COLOR_MAP = {
    'black': '#000000',
    'white': '#ffffff',
    'red': '#e53935',
    'blue': '#1e88e5',
    'green': '#43a047',
    'yellow': '#fdd835',
    'orange': '#fb8c00',
    'purple': '#8e24aa',
    'pink': '#d81b60',
    'brown': '#6d4c41',
    'grey': '#757575',
    'gray': '#757575',
    'navy': '#1a237e',
    'beige': '#d7ccc8',
    'cream': '#fffde7',
    'gold': '#ffd700',
    'silver': '#c0c0c0',
    'maroon': '#800000',
    'olive': '#808000',
    'teal': '#008080'
};

/**
 * Get hex color code from a color name
 * Falls back to generating a hash-based color for unknown names
 * @param {string} colorName - The name of the color
 * @returns {string} Hex color code
 */
export function getColorCode(colorName) {
    if (!colorName) return '#757575';

    const lower = colorName.toLowerCase();

    // Check known colors first
    if (COLOR_MAP[lower]) {
        return COLOR_MAP[lower];
    }

    // Generate a hash-based color for unknown color names
    const hash = lower.split('').reduce((acc, char) => {
        return acc + char.charCodeAt(0).toString(16);
    }, '');

    return '#' + hash.slice(0, 6).padEnd(6, '0');
}

/**
 * Determine if a given color name represents a light color
 * @param {string} colorName - The name of the color
 * @returns {boolean} True if the color is light
 */
export function isColorNameLight(colorName) {
    const lightColors = ['white', 'cream', 'beige', 'yellow', 'silver', 'gold'];
    return lightColors.includes(colorName?.toLowerCase());
}
